/*
 *  Copyright (C) 2019 schroeder.org - All Rights Reserved
 *  Unauthorized copying of this file or deriving works therefrom,
 *  via any medium, is strictly prohibited
 *  Proprietary and confidential
 *  <dev@schroeder.org>
 */

// status to prune to active subset of total (local storage) dictionary
export enum DictWordStatus {
  enabled = 'enabled',
  disabled = 'disabled',
  removed = 'removed',
}

// dictionary word and its history stats
type EventTimestampList = number[];

export interface IDictWord {
  hashCode: number,
  status: DictWordStatus;
  heard: EventTimestampList;
  correct: EventTimestampList;
  errorTotal: EventTimestampList;
  errorMissingArticle: EventTimestampList;
  errorWrongArticle: EventTimestampList;
  errorCapitalization: EventTimestampList;
  errorIncorrect: EventTimestampList;
}

export interface IDictLesson {
  [key: string]: IDictWord;
}

export interface IDictGroup {
  [key: string]: IDictLesson;
}

interface IDict {
  [key: string]: IDictGroup;
}

export interface IHistoryVersion {
  major: number,
  minor: number,
}

export interface IHistoryDict {
  version: IHistoryVersion,
  dict: IDict,
}

export default IDict;
